import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import StyledSelect from './DiallingCodesSelector.styles';
import diallingCodes from '../../../constants/diallingCodes';
import countries from '../../../constants/countries';

const priority = {
  GB: 5,
  FR: 4,
  BE: 3,
  NL: 2,
  DE: 1
};

const sortedCountries = [...countries].sort((a, b) => (priority[b.code] || 0) - (priority[a.code] || 0));

const diallingCodesOptions = sortedCountries.map(({ code, name }) => ({
  value: diallingCodes[code]?.diallingCode,
  label: `(+${diallingCodes[code]?.diallingCode ?? ''}) ${name}`,
  inputLabel: `+${diallingCodes[code]?.diallingCode}`
}));

const findOption = (codeValue) =>
  diallingCodesOptions.find(
    ({ value, label }) => (codeValue === value && (value !== '44' || (value === '44' && label?.includes('United Kingdom')))) ?? undefined
  );

const getInputOption = (option) =>
  option?.value
    ? {
        value: option.value,
        label: option.inputLabel
      }
    : undefined;

const DiallingCodesSelector = ({
  'data-testid': testId,
  'data-cy': cyId,
  id,
  name,
  validate,
  required,
  initialValue,
  isInvalid,
  disabled,
  classes = '',
  onChange: onChangeProp
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required, validate }}
      defaultValue={getInputOption(findOption(initialValue))}
      render={({ field: { ref, name, value, onChange, onBlur } }) => (
        <StyledSelect
          id={id}
          data-cy={cyId}
          data-testid={testId}
          name={name}
          ref={ref}
          value={getInputOption(findOption(value))}
          classNamePrefix="react-select"
          options={diallingCodesOptions}
          isInvalid={isInvalid}
          blurInputOnSelect
          isDisabled={disabled}
          classes={classes}
          onChange={(option) => {
            onChange(option?.value);
            onChangeProp?.(option?.value);
          }}
          onBlur={onBlur}
        />
      )}
    />
  );
};

DiallingCodesSelector.propTypes = {
  'data-testid': PropTypes.string,
  'data-cy': PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  initialValue: PropTypes.string,
  onChange: PropTypes.func,
  isInvalid: PropTypes.bool,
  validate: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  classes: PropTypes.string
};

export default DiallingCodesSelector;
